import { Link } from "react-router-dom";

export default function Unauthorized() {
  return (
    <div className="login-page">
      <div className="login-card">
        <h2 className="login-title">403 Unauthorized</h2>
        <p className="login-subtitle">
          Access denied. You do not have permission to view this page.
        </p>
        <Link to="/login" className="btn btn-primary">
          Back to Login
        </Link>
      </div>
    </div>
  );
}
